/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { BroadcastMessageCategoryResultDto } from '../../models/broadcast-message-category-result-dto';

export interface GetBroadcastMessageCategories$Params {}

export function getBroadcastMessageCategories(
  http: HttpClient,
  rootUrl: string,
  params?: GetBroadcastMessageCategories$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<BroadcastMessageCategoryResultDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    getBroadcastMessageCategories.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BroadcastMessageCategoryResultDto>;
      }),
    );
}

getBroadcastMessageCategories.PATH = '/message/category';
